
import React ,{ Component } from 'react';
import './styles.css';
import PageNotFound from '../errorPages/pageNotFound/PageNotFound';
class Login extends Component {
  // Adding/Removing the class will manage the header
  componentDidMount() {
    document.getElementById("headerMain").classList.add("loginclass");
    document.getElementById("antTab").classList.add("loginclass");
  };

  componentWillUnmount(){
    document.getElementById("headerMain").classList.remove("loginclass");
    document.getElementById("antTab").classList.remove("loginclass");  
  }

  render() {
    return (
      <PageNotFound />
    );
  }
}

export default Login;